import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { QueryFunction } from '@tanstack/react-query';
import { ExternalField, ExternalFieldResponse } from './types';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

const getExternalFields: QueryFunction<
  ExternalField[],
  ['/external-fields', string]
> = async ({ queryKey }) => {
  if (isMockServices()) return await mock(_mockData(queryKey[1]));

  const source = queryKey[1];
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<ExternalFieldResponse>(
    `/external-fields?source=${source}`,
    {
      method: 'GET',
      paginate: true,
      accumulateKey: 'externalFields',
      nextCursorKey: 'nextCursor',
      limit: 100,
    }, // Type assertion to allow custom props
  );

  return response.data?.externalFields ?? [];
};

export default getExternalFields;

const _mockData = (sourceType: string): ExternalField[] =>
  new Array(50).fill(null).map(
    (_, index) =>
      ({
        id: `mock-field-${index}`,
        name: `Mock Field ${index}`,
        source: sourceType,
        metadata: {
          form_name: `Mock Form ${index}`,
          source_field_id: `VEND.${index}`,
        },
        isDeleted: false,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      }) as ExternalField,
  );
